import React, { useEffect, useState } from 'react'
import { ArrowBigUpDash, Fullscreen } from 'lucide-react'
import { HTTP } from '../../api/http-common'
import { useNavigate } from 'react-router-dom'
import { CustomModal } from '../../component/ReusableComponents'

const GridImageGallery = () => {
  const navigate = useNavigate()

  const [galleryList, setGalleryList] = useState([]);

  const [isModalOpen, setIsModalOpen] = useState(false)
  const [selectedImage, setSelectedImage] = useState(null)

  const handleModalToggle = (image = null) => {
    setSelectedImage(image)
    setIsModalOpen(!isModalOpen)
    console.log('clicked');

  }

  const loadGalleryList = async () => {
    const access_token = localStorage.getItem('access_token');
    const config = {
      headers: { 'Content-Type': 'application/json', token: access_token },
    };
    let fields = {};

    HTTP.post('/user/media_gallery/list', fields, config)
      .then((response) => {
        const data = response.data;
        if (response.status === 200) {
          setGalleryList(data.contents);
        }
        console.log('data for image', data);
      })
      .catch((error) => {
        if (error.response && error.response.status === 401) {
          localStorage.clear();
          navigate('/'); // Redirect to login page
        }
      });
  };
  useEffect(() => {
    loadGalleryList();
  }, []);
  return (
    <>
      <div className=''>
        <div className="md:pt-6 pt-2"  aos-dealy="600">
          <div className="mx-auto px-4">
            <div className="text-center">
              <h6 className="section-title py-2">Photo Gallery</h6>
            </div>
          </div>
        </div>

        <div className="lg:px-6 px-2">
          {galleryList.length > 0 ? (
            <div className="gird-list ">
              {galleryList.map((item, index) => (
                <div
                  key={item.id}
                  className="grid-list-child"
               
                >
                  <img onClick={() => handleModalToggle(item)} src={item.path} alt={item.title} className="gallery-image" />
                  <div className="">
                    <div className="grid-list-child-description">
                      <span className="flex align-items-center justify-center ">
                        <ArrowBigUpDash />
                      </span>
                      <span className="flex justify-between items-center ">
                        <h2 className='font-bold text-xl pb-1'>{item.title}</h2>
                        <button
                          className='px-2  relative z-0 show-popup-detail-button'
                          onClick={() => handleModalToggle(item)}
                        >
                          <Fullscreen />
                        </button>
                      </span>

                      <span className="">
                        {/* <p className='px-2'>{item.description}</p> */}
                        <p className='px-2'>
                          {item.description.length > 200 ? `${item.description.substring(0, 200)}...` : item.description}
                        </p>
                      </span>
                    </div>
                  </div>
                </div>
              ))}
            </div>

          ) : (
            <p>Loading gallery...</p>
          )}
        </div>
      </div>
      <CustomModal width='80%' className='gallery-modal' isOpen={isModalOpen} onClose={() => handleModalToggle(null)}>
        {selectedImage && (
          <div className="flex md:flex-row flex-col">
            <div className="md:w-1/3 w-full md:pr-4 ">
              <img
                src={selectedImage.path}
                alt={selectedImage.title}
                className="w-100 w-auto object-contain"
              />
            </div>
              <div className="p-4 md:px-0">
                <h3 className="text-[25px] font-bold mb-2">{selectedImage.title}</h3>
                <p className="px-3 text-gray-600">{selectedImage.description}</p>
              </div>
          </div>
        )}
      </CustomModal>
    </>
  )
}

export default GridImageGallery